export default __webpack_public_path__ + "static/media/bg-dashboard-2.855b3883.png";